import { render, staticRenderFns } from "./cases.vue?vue&type=template&id=65ffa79e&scoped=true"
import script from "./cases.vue?vue&type=script&lang=js"
export * from "./cases.vue?vue&type=script&lang=js"
import style0 from "./cases.vue?vue&type=style&index=0&id=65ffa79e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ffa79e",
  null
  
)

export default component.exports